import { motion } from 'framer-motion';
import React, {useState, useContext, useEffect} from 'react';
import { RiAddCircleLine } from 'react-icons/ri';
import { useHistory } from 'react-router';
import { SettingsContext } from '../../Context';
import VideoManager from '../../Managers/VideoManager';
import "./VideoShelf.css"
import banner from '../../Assets/Images/banner_1024_500.png'
import { Image } from '../Image/Image';


export const VideoTile = props => {
    const { item, animation} = props
   const { locale } = useContext(SettingsContext)

   const history = useHistory()
   const [hover, setHover] = useState(false)
   const [image, setImage] = useState("")
   
   useEffect(() => {

    setImage(props.item?.thumbnail)
   },[])

   const handleClick = () => {
        VideoManager.setVideo(item)
   }

   const setHoverTrue = () => setHover(true)
   const setHoverFalse = () => setHover(false)
   return (
       <motion.div className="video-container" onClick={handleClick}>
           <motion.div className="video-cover video-cover-color video-cover-container">
               <div className="vcc-top"
                       onMouseEnter={setHoverTrue}
                       onMouseLeave={setHoverFalse}
               >
                   <span style={{
                       opacity: hover ? 1 : 0
                   }}>{locale.addToList}</span>
                   <div 
               
                   >
                       <RiAddCircleLine 
                       size={24}
                       color={hover ? "green" : "white"}/>
                   </div>
               </div>
               <div className="vcc-bottom">
                   <span className="vcc-program">{item?.program_name} </span>
                   <span className="vcc-episode">{item?.name}</span>
               </div>
           </motion.div>

           <Image 
               animation={animation}
               className="video-image"
               key={`video-thumbnail-${item?.name}`}
               src={image} 
                onError={() => setImage(banner)}
               alt="video image" 
               />
           <div className="video-progress-track ">

           </div>
       </motion.div>
   )
}